import { render, staticRenderFns } from "./DisplaySubMenu.vue?vue&type=template&id=deda3c4e&scoped=true&"
import script from "./DisplaySubMenu.vue?vue&type=script&lang=js&"
export * from "./DisplaySubMenu.vue?vue&type=script&lang=js&"
import style0 from "./DisplaySubMenu.vue?vue&type=style&index=0&id=deda3c4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deda3c4e",
  null
  
)

component.options.__file = "DisplaySubMenu.vue"
export default component.exports